import { render } from "./PrescriptionPrintTemplateDefault.vue?vue&type=template&id=ddbea192&scoped=true"
import script from "./PrescriptionPrintTemplateDefault.vue?vue&type=script&lang=js"
export * from "./PrescriptionPrintTemplateDefault.vue?vue&type=script&lang=js"

import "./PrescriptionPrintTemplateDefault.vue?vue&type=style&index=0&id=ddbea192&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbea192"]])

export default __exports__